
import React from 'react';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import isNil from 'lodash/isNil';

import { utils } from '../../../core';

const ObjectEditAttributeCombobox = ({
    attribute,
    onChange,
    value
}) => {

    const handleChange = (e, item) => {
        if (onChange) {
            onChange(attribute.name, item.key);
        }
    }

    const getOptions = () => {
        let options = [];

        options = [
            ...options,
            ...attribute.values.map(item => {
                return {
                    key: item[0],
                    text: item[1]
                }
            })
        ];
        return options;
    }

    const getValue = () => {
        return (isNil(value))
            ? ''
            : `${value}`;
    }

    let readOnly = false;

    return (
        <ComboBox
            label={attribute.title}
            disabled={readOnly}
            readOnly={readOnly}
            options={getOptions()}
            selectedKey={getValue()}
            styles={utils.styles.COMBO_BOX_STYLES}
            onChange={handleChange}
        />
    );
}

export default ObjectEditAttributeCombobox;
